export const formatDate = (value?: Date | string): string => {
  if (!value) return "—";

  const date = typeof value === "string" ? new Date(value) : value;

  if (Number.isNaN(date.getTime())) {
    return value.toString();
  }

  return new Intl.DateTimeFormat("de-AT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
};

export const toDate = (value?: string): Date | undefined => {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const isSameDay = (left?: string, right?: string) =>
  toDate(left)?.toDateString() === toDate(right)?.toDateString();

export const formatValue = (value?: string | number | null): string => {
  if (value === null || value === undefined || value === "") return "—";
  return String(value);
};

export const getStudiengangsArtText = (
  value?: string | number | null,
): string => {
  switch (Number(value)) {
    case 2:
      return "Bachelor";
    case 3:
      return "Master";
    case 4:
      return "Lehrgang";
    default:
      return "—";
  }
};
